import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpHeaders
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { EnvironmentService } from '../services/environment.service';
import { LocalStorageService } from '../services/local-storage.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private _auth: AuthService, private _environmentService: EnvironmentService, private localStorageService: LocalStorageService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const configFile = environment.envName === 'local' ? '/assets/config-local.json' : '/assets/config.json';
    if (req.url === configFile) {
      // Skip the interceptor for this specific request
      return next.handle(req);
    }

    let modifiedRequest = req;

    // Add Authorization header if user is logged in
    if (this._auth.isLoggedIn()) {
      modifiedRequest = modifiedRequest.clone({
        setHeaders: {
          'Content-Type': 'application/json; charset=utf-8',
          'Accept': 'application/json',
          'Authorization': `Bearer ${this._auth.getProp('token')}`,
        },
      });
    }

    // Determine which API key to use based on the URL
    const isAssetsRequest = req.url.includes('/client/assets/');
    const apiKey = isAssetsRequest 
      ? environment.assetsApiKey 
      : this._environmentService.getFacilityConfig()?.facilityApiV2Key;

    if (apiKey) {
      modifiedRequest = modifiedRequest.clone({
        setHeaders: {
          'x-api-key': apiKey
        }
      });
    }

    // Add X-Location-Id header if location is selected
    const locationId = this.getLocationId();
    if (locationId && !req.headers.has('X-Location-Id')) {
      modifiedRequest = modifiedRequest.clone({
        setHeaders: {
          'X-Location-Id': locationId.toString()
        }
      });
    }

    // Add X-Source header
    if (!req.headers.has('X-Source')) {
      modifiedRequest = modifiedRequest.clone({
        setHeaders: {
          'X-Source': 'Website'
        }
      });
    }

    // Skip interceptor if X-Skip-Interceptor header is present
    if (req.headers.has('X-Skip-Interceptor')) {
      modifiedRequest = req.clone({
        headers: new HttpHeaders(), // No headers
      });
    }

    return next.handle(modifiedRequest);
  }

  getLocationId(): number | null {
    const location = this.localStorageService.getLocation();
    if (location) {
      return location.Id;
    }
    return null;
  }
}
